"use client";
import { Box } from "../../core/Box/Box.mjs";
import { useModalBaseContext } from "./ModalBase.context.mjs";
import ModalBase_module_default from "./ModalBase.module.mjs";
import cx from "clsx";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/ModalBase/ModalBaseHeader.tsx
function ModalBaseHeader({ className, ...others }) {
	const ctx = useModalBaseContext();
	return /* @__PURE__ */ jsx(Box, {
		component: "header",
		className: cx({ [ModalBase_module_default.header]: !ctx.unstyled }, className),
		...others
	});
}
ModalBaseHeader.displayName = "@mantine/core/ModalBaseHeader";
//#endregion
export { ModalBaseHeader };

//# sourceMappingURL=ModalBaseHeader.mjs.map